import { render, staticRenderFns } from "./_Notes.vue?vue&type=template&id=5ce9616c"
import script from "./_Notes.vue?vue&type=script&lang=js"
export * from "./_Notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports